import React, { Component } from 'react';
import { withTheme } from 'styled-components';
import Button from 'core/components/Button';
import AnchorButton from 'core/components/AnchorButton';
import Tooltip from 'core/components/Tooltip';

@withTheme
class ButtonGroupTab extends Component {
  render() {
    const { disabledTooltip, selectedTabId, onClick, id, title, theme, ...rest } = this.props;
    const active = selectedTabId === id;

    const ButtonComponent = disabledTooltip ? AnchorButton : Button;

    const extraProps = {};
    if (active && theme && theme.name === 'dark') {
      extraProps.activeBg = 'darkGray2';
    }

    const content = (
      <ButtonComponent p="6px 10px" active={active} onClick={() => onClick(id)} {...extraProps} {...rest}>
        {title}
      </ButtonComponent>
    );

    if (disabledTooltip && rest.disabled) {
      return (
        <Tooltip key={title} content={disabledTooltip}>
          {content}
        </Tooltip>
      );
    }

    return content;
  }
}

export default ButtonGroupTab;
